/**
 * O "Copiar link" do Mirezi passa a copiar o link curto — card 1901103750345393451.
 *
 * O link longo (`/workspace/<id do espaço>/<id do documento>`) carrega um UUID, e o WhatsApp lê
 * UUID como chave Pix aleatória: a mensagem vira "Copy Pix key" e não monta prévia. O curto é
 * `/s/<id do documento>`; o servidor (`plugins/tuninho/link-curto.ts`) mostra o cartão quando o
 * documento é público e leva ao login quando não é — a mesma permissão do link longo.
 *
 * Link que aponta para um bloco ou elemento selecionado continua longo: ele carrega a seleção.
 * Gêmeo do servidor: o formato `/s/<id>` mora lá também (`link-curto-puro.ts`).
 */
export function linkCurtoDoDoc({
  baseUrl,
  pageId,
  mode,
  blockIds,
  elementIds,
}: {
  baseUrl: string;
  pageId: string;
  mode?: string;
  blockIds?: string[];
  elementIds?: string[];
}): string | undefined {
  if (blockIds?.length || elementIds?.length || !pageId) return undefined;
  try {
    const url = new URL(`/s/${encodeURIComponent(pageId)}`, baseUrl);
    if (mode === 'edgeless') url.searchParams.set('mode', 'edgeless');
    return url.toString();
  } catch {
    return undefined;
  }
}
